import { Flex, Typography } from "antd";
import type { ComponentProps, ReactNode } from "react";

export const FormRow: React.FC<{ children?: ReactNode }> = ({ children }) => (
  <Flex align="baseline" gap={12} wrap className="max-w-full min-w-5 w-full">
    {children}
  </Flex>
);

type LabelProps = Omit<ComponentProps<typeof Typography.Text>, "type"> & {
  width?: 18 | 20;
};

const WIDTH_CLASS: Record<NonNullable<LabelProps["width"]>, string> = {
  18: "min-w-18",
  20: "min-w-20",
};

export const RowLabel: React.FC<LabelProps> = ({
  width = 18,
  className,
  ...rest
}) => (
  <Typography.Text
    type="secondary"
    className={`inline-block ${WIDTH_CLASS[width]} ${className ?? ""}`}
    {...rest}
  />
);
